import React from 'react';
import BannerNoInstalacion from '../../layouts/BannerNoInstalacion';

const MaterialDeckTablonWpc = () => {
  return (
    <>
      <style>{`
        .img-deck-wrapper {
          width: 100%;
          height: 320px;
          overflow: hidden;
          border-radius: 0.5rem;
          box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
        }

        @media (min-width: 768px) {
          .img-deck-wrapper { height: 420px; }
        }

        @media (min-width: 992px) {
          .img-deck-wrapper { height: 500px; }
        }

        .img-deck-wrapper img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center center;
          display: block;
        }
      `}</style>

      <section className="pb-0 mb-20">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="pe-lg-5">
                <div className="img-deck-wrapper">
                  <img
                    src="/assets/img/productos/piso-deck-wpc/deck-tablon-wpc-01.png"
                    alt="Tecnología WPC Coextruido"
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="ps-lg-4">
                <div className="title-style2 mb-4">
                  <h2 className="h1">Tecnología WPC Coextruido</h2>
                </div>
                <p className="lead text-primary font-weight-600 mb-3">
                  Innovación que fusiona la naturaleza con la ingeniería.
                </p>
                <p className="mb-4">
                  El Deck Tablon WPC está fabricado mediante un proceso avanzado de <strong>coextrusión</strong>. Esta técnica combina materiales fundidos (una mezcla precisa de madera natural y polímeros de alta calidad) y los moldea simultáneamente en capas.
                </p>
                <p>
                  El resultado es un núcleo sólido protegido por una capa exterior blindada de 360 grados. Esta "cáscara" protectora hace que la superficie sea mucho más <strong>resistente a las manchas, a la decoloración por rayos UV y al desgaste</strong>, garantizando una vida útil superior a los decks tradicionales.
                </p>
                <div className="w-xl-90 w-xxl-80 mb-6">
                  <BannerNoInstalacion />
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default MaterialDeckTablonWpc;